export class LogSession {
    ExternalSessionCode: string;
    ReportingTag: string;
    SourceUrl: string;
    SourceUrlTitle: string;
}